import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import { Switch } from "src/@/components/ui/switch";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";
import { formatarCanaisParaSelect } from 'src/utils/canaisDisparo';

const CardChatFinish = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    const { t } = useTranslation('automation');
    const { cliente } = useAuth();
    const [configCrm, setConfigCrm] = useState(null);
    const [canais, setCanais] = useState([]);

    async function buscarConfigCrm(querys) {
        try {
            const result = await v2_actionConfigCrm(cliente._id, querys);
            if (result.data.data) {
                setConfigCrm(result.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function buscarListaCanais() {
        try {
            const response = await actionListaCanaisPorCliente(cliente._id);
            setCanais(response.data.data || []);
        } catch (error) {
            console.error("Erro ao buscar lista de canais:", error);
        }
    }

    let canaisFormatted = formatarCanaisParaSelect(canais);

    useEffect(() => {
        if (actionState?.pipelineId) {
            let querys = `?pipeline_id=${actionState?.pipelineId}`;
            buscarConfigCrm(querys);
        } else {
            buscarConfigCrm();
        }
        buscarListaCanais();
    }, [actionState])

    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        isRequired={true}
                        label={t('actionCard.shared.channelLabel', 'Canal')}
                        info={t('actionCard.shared.channelInfo', 'Canais que estão atrelados ao chat')}
                        input={
                            <MultiSelect
                                options={canaisFormatted}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chatChannels", value: e })
                                }
                                defaultValue={actionState.chatChannels}
                                placeholder={t('actionCard.shared.channelPlaceholder', 'Selecionar canais')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <RowInput
                        label={t('actionCard.shared.usersLabel', 'Usuários')}
                        input={<MultiSelect
                            options={users}
                            onValueChange={(e) => {
                                console.log(e);
                                let event = {
                                    name: "chatUsersAssign",
                                    value: e
                                }
                                changeActionState(event);
                            }}
                            defaultValue={actionState?.chatUsersAssign}
                            placeholder={t('actionCard.shared.usersPlaceholder', 'Selecionar usuarios')}
                            variant="inverted"
                            animation={2}
                            maxCount={3}
                        />}
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardChatFinish;
